import { useCallback } from 'react';

import { useUIStore } from '@/stores/uiStore';

export interface ToastOptions {
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

export function useToast() {
  const showToast = useUIStore(state => state.showToast);

  const toast = useCallback(
    (options: ToastOptions) => {
      const message = options.description
        ? `${options.title}: ${options.description}`
        : options.title;

      showToast({
        message,
        type: options.type || 'info',
        duration: options.duration || 5000,
      });
    },
    [showToast]
  );

  return { toast };
}
